import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import styles from "./index.module.scss";
import { Button, Modal, Select } from "antd";
import useRequestFn from "Utils/useRequestFn";
import { base64toFile } from "API";

interface WebCamBodyProps {
    onOk: (file: File) => Promise<void>;
}

export default function WebCamBody({ onOk }: WebCamBodyProps) {
    const [loaded, setLoaded] = useState(false); // 摄像头已开始工作
    const [deviceId, setDeviceId] = React.useState<string>("");
    const [devices, setDevices] = React.useState<MediaDeviceInfo[]>([]);
    const [error, setError] = useState<any>();

    const webcamRef = useRef<Webcam>(null);
    const [snapshot, setSnapshot] = useState<string>("");
    const [file, setFile] = useState<File>(); //base64转化成file格式后的文件

    const [saveData, { loading }] = useRequestFn(onOk);

    useEffect(() => {
        if (!loaded) return;
        try {
            navigator.mediaDevices.enumerateDevices().then(mediaDevices => {
                const deviceList = mediaDevices.filter(
                    ({ kind }) => kind === "videoinput"
                );
                setDevices(deviceList);
                setDeviceId(deviceList[0]?.deviceId);
            });
        } catch (e) {
            Modal.error({ content: "您的设备无可用摄像头" });
        }
    }, [loaded]);

    async function takeSnapshot() {
        const snapshot = webcamRef.current?.getScreenshot() || "";
        const file = base64toFile(snapshot); //base64转file
        setSnapshot(snapshot);
        setFile(file);
    }

    async function submitSnapshot() {
        if (!file) return;
        saveData(file);
    }

    function onUserMedia(stream: MediaStream) {
        setError(undefined);
        setLoaded(true);
    }

    function onUserMediaError(error: any) {
        setError(error);
    }

    return (
        <div className={styles.root}>
            <div className={styles.left}>
                <Webcam
                    ref={webcamRef}
                    style={{ display: snapshot ? "none" : "" }}
                    videoConstraints={{ deviceId }}
                    onUserMedia={onUserMedia}
                    onUserMediaError={onUserMediaError}
                    minScreenshotHeight={400}
                    minScreenshotWidth={600}
                    screenshotQuality={0.8}
                    screenshotFormat="image/jpeg"
                />

                {snapshot && <img src={snapshot} alt="采集结果" />}

                {error && (
                    <div className={styles.error}>
                        检测到摄像头无法正常工作，请重启电脑、更换摄像头或更换电脑。
                    </div>
                )}
            </div>

            <div className={styles.right}>
                {devices.length > 1 && (
                    <Select
                        placeholder="请选择摄像头"
                        value={deviceId}
                        onSelect={setDeviceId}
                        style={{ width: "100%", marginBottom: 10 }}>
                        {devices.map(item => (
                            <Select.Option
                                key={item.deviceId}
                                value={item.deviceId}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                )}
                {devices.length === 0 && (
                    <div className={styles.tip}>无可用摄像头</div>
                )}
                提示：
                <br />
                请调整好坐姿后再进行拍摄。
                {!error && loaded && (
                    <div className={styles.buttons}>
                        {!snapshot && (
                            <Button type="primary" onClick={takeSnapshot}>
                                拍照
                            </Button>
                        )}

                        {snapshot && (
                            <>
                                <Button
                                    onClick={() => setSnapshot("")}
                                    disabled={loading}>
                                    重拍
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={submitSnapshot}
                                    loading={loading}>
                                    提交
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
